<template>
  <figure v-lazyload class="image__wrapper">
    <!-- <ImageSpinner
      class="image__spinner"
    /> -->
    <img
      class="image__item"
      :data-url="source"
      :data-alt="name"
      v-tippy="{ placement : 'bottom right',  arrow: false , content: name, followCursor : true, animation: 'false', maxWidth: 600}"
    >
  </figure>
</template>

<script>
import { tippy } from "vue-tippy";
import ImageSpinner from "./ImageSpinner";

export default {
  name: "ImageItem",
  components: {
    ImageSpinner
  },
  props: {
    source: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped>
/*.image {
  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    &.loaded {
      .image {
        &__item {
          visibility: visible;
          opacity: 1;
          border: 0;
        }

        &__spinner {
          display: none;
          width: 100%;
        }
      }
    }
  }

  &__item {
    width: 100%;
    border-radius: 4px;
    transition: all 0.4s ease-in-out;
    opacity: 0;
    visibility: hidden;
  }
}*/
</style>
